import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import img30 from "../../../Assets/Images/30_plus.svg";
import './Style.scss'

export class AboutContainer extends Component {
  render() {
    return (
      <>
        <section className="aboutSectionContainer">
          <Container className="aboutSection">
            <Row className="rows">
              <Col md={4}>
                <div className="imgContainer">
                  <img src={img30} alt="30+ illustration" />
                  <h3>EXPERIENCE IN <br /> FINANCIAL MARKETS</h3>
                </div>
              </Col>
              <Col md={8}>
                <div className="txtContainer">
                  <h2>OPG Group</h2>
                  <h4>India's Growing Trading Firm</h4>
                  <p className="disc">
                    Personalised and world class, we at OPG Group improve the
                    health of your wealth. OPG Provides one of the best trading
                    platform with cutting edge technology. As a process-led and
                    professionally managed company, we consistently deliver
                    superior returns to our investors. With the
                    knowledge-is-power approach, we hold our pulse on the
                    market.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default AboutContainer;
